// extracted by mini-css-extract-plugin
export default {"reportHeader":"blockBusinessCreditReport_reportHeader__1C7rB","reportHeaderTitle":"blockBusinessCreditReport_reportHeaderTitle__gkK5D"};